var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 517.4 74.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VidyoConnect-Colored-Horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Small_Colored",
    "data-name": "Small Colored"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.34 54.96 36.34 68.07 68.15 68.07 68.15 36.26 55.76 36.26 55.76 54.96 36.34 54.96",
    style: {
      fill: "#128bca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.48 36.26 0.08 36.26 0.08 68.07 31.89 68.07 31.89 54.96 12.48 54.96 12.48 36.26",
    style: {
      fill: "#89c040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.76 31.82 68.15 31.82 68.15 0 36.34 0 36.34 11.68 55.76 11.68 55.76 31.82",
    style: {
      fill: "#89c040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.89 11.68 31.89 0 0.08 0 0.08 31.82 12.48 31.82 12.48 11.68 31.89 11.68",
    style: {
      fill: "#128bca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,31.82V18.13H36.34V11.68H31.89v6.45H18.21V31.82H12.48v4.44h5.73V49.94H31.89v5h4.44v-5H50V36.26h5.73V31.82ZM41,28.12V41H27.27V27.29H41Z",
    style: {
      fill: "#f9c11f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.72 48.69 89.68 10.06 83.26 10.06 99.66 58.67 105.64 58.67 122.55 10.06 116.06 10.06 102.72 48.69",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,12A3.49,3.49,0,0,0,126,15.6a3.47,3.47,0,0,0,3.5,3.57,3.57,3.57,0,0,0,.07-7.14Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.71,
    y: 25.07,
    width: 5.54,
    height: 33.6,
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,30.17a14.41,14.41,0,0,0-12-5.9c-9.11,0-15.82,7.58-15.82,17.79s6.56,17.42,15.82,17.42c5.1,0,8.67-2,12-6.56v5.76h5.54V10.06h-5.54ZM154.41,54.67c-6.34,0-10.79-5.18-10.79-12.54,0-7.65,4.52-12.9,11.15-12.9,6.41,0,10.86,5.18,10.86,12.76C165.63,49.27,160.89,54.67,154.41,54.67Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.03 50 179.99 25.07 174.09 25.07 186.04 57.65 179.05 74.86 185.1 74.86 205.14 25.07 199.09 25.07 189.03 50",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.53,24.27c-10.2,0-17.2,7.14-17.2,17.57s7,17.64,17,17.64A17.16,17.16,0,0,0,241.52,42C241.52,31.63,234.45,24.27,224.53,24.27Zm-.07,30.1c-6.85,0-11.44-5-11.44-12.46s4.59-12.54,11.52-12.54,11.3,5,11.3,12.54C235.83,49.2,231.09,54.37,224.46,54.37Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,14.79c5.18,0,8.75,1.75,13.48,6.63l4.23-3.94a25.43,25.43,0,0,0-5.69-5,23.77,23.77,0,0,0-12.17-3.28c-13.41,0-23.25,10.64-23.25,25.22a27.49,27.49,0,0,0,6.49,18,21.64,21.64,0,0,0,16.69,7.14c7.51,0,12.9-2.48,17.79-8.24L286,47.23c-3.79,4.59-7.87,6.71-13.19,6.71-10.06,0-17.42-8.24-17.42-19.54S262.58,14.79,272.5,14.79Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,24.27c-10.2,0-17.2,7.14-17.2,17.57s7,17.64,17,17.64A17.16,17.16,0,0,0,328.7,42C328.7,31.63,321.63,24.27,311.71,24.27Zm-.07,30.1c-6.85,0-11.44-5-11.44-12.46s4.59-12.54,11.52-12.54,11.3,5,11.3,12.54C323,49.2,318.28,54.37,311.64,54.37Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.77,24.27c-4.15,0-7.07,1.6-10,5.54V25.07h-5.54v33.6h5.54V38.19A7.93,7.93,0,0,1,342,32.07a8.36,8.36,0,0,1,6.41-2.84,6.47,6.47,0,0,1,5.25,2.26c.88,1.17,1.24,2.77,1.24,5.76V58.67h5.54V36c0-4.59-.73-6.92-2.84-9A11.69,11.69,0,0,0,349.77,24.27Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,24.27c-4.15,0-7.07,1.6-10,5.54V25.07h-5.54v33.6H374V38.19a7.93,7.93,0,0,1,2.19-6.12,8.36,8.36,0,0,1,6.41-2.84,6.47,6.47,0,0,1,5.25,2.26c.88,1.17,1.24,2.77,1.24,5.76V58.67h5.54V36c0-4.59-.73-6.92-2.84-9A11.7,11.7,0,0,0,384,24.27Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.83,24.27c-9.84,0-16.91,7.36-16.91,17.71S407.06,59.48,417,59.48a16.45,16.45,0,0,0,14.94-9l-4.88-1.82A11.63,11.63,0,0,1,417,54.37a10.93,10.93,0,0,1-9-4.59,10.47,10.47,0,0,1-2.19-6.12h28c.07-.8.07-1.75.07-2.19C433.89,31.63,426.6,24.27,416.83,24.27ZM405.9,39.58a13.33,13.33,0,0,1,1.89-5.69,10.8,10.8,0,0,1,9-4.67,11.53,11.53,0,0,1,9.26,4.59,10.41,10.41,0,0,1,1.9,5.76Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.2,29.37a12.34,12.34,0,0,1,8.53,3.5l3.57-3.57a16.61,16.61,0,0,0-12.25-5c-9.84,0-16.76,7.29-16.76,17.71,0,10.2,6.85,17.49,16.47,17.49a17.22,17.22,0,0,0,12.39-5l-3.43-3.79a11.76,11.76,0,0,1-8.6,3.64c-6.56,0-11.15-5.18-11.15-12.61S446.57,29.37,453.2,29.37Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.45 25.07 479.45 14.5 473.91 14.5 473.91 25.07 469.24 25.07 469.24 29.95 473.91 29.95 473.9 59.48 479.45 59.48 479.45 29.95 484.55 29.95 484.55 25.07 479.45 25.07",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.38,25.57H493.2V17.2H490.8v-1h6v1h-2.38Z",
    style: {
      fill: "#50565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.2,25.57H498V16.18h1.17l3.48,7,3.52-7h1.15v9.38h-1.18V18.7l-3.49,7-3.46-7Z",
    style: {
      fill: "#50565b"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/Logo_black.66f7712f4f8b3e8034df416789a887ec.svg";
export { ForwardRef as ReactComponent };